import React from "react";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { humanize } from "../utils";

const FilterTabs = ({
  handleTabClick,
  options=[],
  selectedTab,
}) => {
  return (
    <>
      <ul className="nav border-bottom border-muted mb-3">
        {options.map((option) => {
          const { count, tooltip, value } = option;
          const tabIsActive = selectedTab === value;
          return (
            <OverlayTrigger
              key={value}
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip className="tooltip-small">{tooltip}</Tooltip>}
            >
              <li
                className={`nav-item`}
                onClick={() => handleTabClick(value)}
              >
                <a className={`pointer nav-link ${tabIsActive ? 'active border-bottom border-secondary' : ''}`}>
                  <span className={tabIsActive ? "body-large-18-semibold" : "body-large-18-regular"}>
                    {humanize(value)}
                  </span>
                  <span
                    className="body-medium-bold ms-2"
                    style={{
                      backgroundColor: tabIsActive ? "#EDF0F7" : "#FBFBFB",
                      padding: "2px 8px",
                      borderRadius: "4px",
                    }}
                  >
                    {count}
                  </span>
                </a>
              </li>
            </OverlayTrigger>
          )
        })}
      </ul>
    </>
  );
};

export default FilterTabs;